import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CardFileDTO } from '@src/adapters/dto/card/CardFileDTO';
import File from './File';

interface Props {
  files: CardFileDTO[] | undefined;
}

function Files({ files }: Props) {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '62px',
          backgroundColor: '#f5f7fd',
          border: '1px solid #E6E7E9',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography
          variant="h6"
          sx={(theme) => ({ marginLeft: theme.spacing(3) })}>
          Files
        </Typography>
        <Box>
          <IconButton
            aria-label="logout"
            onClick={() => setExpanded((prev) => !prev)}
            size="large"
            sx={(theme) => ({ marginRight: theme.spacing(1) })}>
            {expanded && <ExpandLessIcon />}
            {!expanded && <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {expanded && files && files.map((f) => <File file={f} key={f.id} />)}
      {expanded && (!files || files.length === 0) && (
        <Typography
          variant="body1"
          color={(theme) => theme.palette.text.disabled}
          sx={(theme) => ({ padding: theme.spacing(3) })}>
          No files to show.
        </Typography>
      )}
    </>
  );
}

export default Files;
